const KEY = 'eating_cashier_desk_session_v1'
const MEMBER_CACHE_KEY = 'eating_cashier_member_cache_v1'
const EXPIRE_MS = 24 * 60 * 60 * 1000

/** 进入/退出收银台时清空会员登录缓存，避免把管理员账号当成会员自动带入 */
export function clearCashierMemberCache() {
  try {
    localStorage.removeItem(MEMBER_CACHE_KEY)
  } catch (_e) {
    // ignore
  }
}

export function openCashierDeskSession() {
  const now = Date.now()
  const payload = {
    issuedAt: now,
    expiresAt: now + EXPIRE_MS
  }
  try {
    localStorage.setItem(KEY, JSON.stringify(payload))
  } catch (_e) {
    // ignore
  }
  clearCashierMemberCache()
  return payload
}

export function readCashierDeskSession() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (_e) {
    return null
  }
}

export function isCashierDeskSessionValid() {
  const s = readCashierDeskSession()
  if (!s) return false
  const exp = Number(s.expiresAt || 0)
  return exp > Date.now()
}

export function clearCashierDeskSession() {
  try {
    localStorage.removeItem(KEY)
  } catch (_e) {
    // ignore
  }
  clearCashierMemberCache()
}

export function cashierDeskRemainMs() {
  const s = readCashierDeskSession()
  if (!s) return 0
  return Math.max(0, Number(s.expiresAt || 0) - Date.now())
}
